import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  Json: any;
  /** Date custom scalar type */
  Date: any;
};

export type ActivityLogEntry = {
  __typename?: 'ActivityLogEntry';
  id: Scalars['String'];
  type: ActivityLogEntryType;
  memo?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  change?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type ActivityLogEntryOrderByInput = {
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  memo?: Maybe<SortOrder>;
  subject?: Maybe<SortOrder>;
  change?: Maybe<SortOrder>;
  userId?: Maybe<SortOrder>;
  orderId?: Maybe<SortOrder>;
  leadId?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  voucherId?: Maybe<SortOrder>;
};

export enum ActivityLogEntryType {
  Created = 'CREATED',
  Update = 'UPDATE',
  StatusChange = 'STATUS_CHANGE',
  Sync = 'SYNC',
  Memo = 'MEMO'
}

export type ActivityLogEntryWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  id: Scalars['String'];
  first_name: Scalars['String'];
  last_name: Scalars['String'];
  company_name: Scalars['String'];
  phone_number: Scalars['String'];
  line_1: Scalars['String'];
  line_2: Scalars['String'];
  city: Scalars['String'];
  postcode: Scalars['String'];
  county: Scalars['String'];
  country: Scalars['String'];
};

export type AddressInput = {
  gender: Gender;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  postalCode: Scalars['String'];
  street: Scalars['String'];
  houseNumber: Scalars['String'];
  houseNumberSuffix?: Maybe<Scalars['String']>;
};

export type AdminAccountActivationInput = {
  activationKey: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AdminsPayload = {
  __typename?: 'AdminsPayload';
  items: Array<User>;
  total: Scalars['Int'];
};

export type Article = {
  __typename?: 'Article';
  id: Scalars['String'];
  articleType: Scalars['String'];
  supplierNr: Scalars['String'];
  brand: Scalars['String'];
  collection?: Maybe<Scalars['String']>;
  collectionNumber?: Maybe<Scalars['Int']>;
  modelName: Scalars['String'];
  eancode: Scalars['String'];
  subCategory: Scalars['String'];
  description: Scalars['String'];
  urlSlug: Scalars['String'];
  inStock: Scalars['Boolean'];
  ignoreStockCheck: Scalars['Boolean'];
  isPriceVisible: Scalars['Boolean'];
  isWebShopOnly: Scalars['Boolean'];
  isWebshopSale: Scalars['Boolean'];
  isOutOfCollection: Scalars['Boolean'];
  price: Scalars['Int'];
  salePrice?: Maybe<Scalars['Int']>;
  images: Array<Scalars['String']>;
  articleAttributes: Array<ArticleAttribute>;
};

export type ArticleAttribute = {
  __typename?: 'ArticleAttribute';
  attributeName: Scalars['String'];
  attributeOriginalName: Scalars['String'];
  attributeValue: Scalars['String'];
  attributeID: Scalars['Int'];
  attributeValueID: Scalars['Int'];
};

export type ArticleAttributeFilter = {
  __typename?: 'ArticleAttributeFilter';
  attributeID: Scalars['Int'];
  attributeName: Scalars['String'];
  articleFilterAttributeValues: Array<ArticleFilterAttributeValue>;
};

export type ArticleFilterAttributeValue = {
  __typename?: 'ArticleFilterAttributeValue';
  attributeValueID: Scalars['Int'];
  attributeValue: Scalars['String'];
};

export type ArticlesFilterInput = {
  attributeFilters?: Maybe<Array<AttributeFilterFiltersInput>>;
  brands?: Maybe<Array<Scalars['Int']>>;
  collections?: Maybe<Array<Scalars['Int']>>;
  articleTypeID?: Maybe<Scalars['Int']>;
  theme?: Maybe<Scalars['String']>;
};

export enum ArticleSortEnum {
  PriceAsc = 'priceASC',
  PriceDesc = 'priceDESC',
  New = 'new'
}

export type ArticlesPaginationInput = {
  sort?: Maybe<ArticleSortEnum>;
  skip?: Maybe<Scalars['Int']>;
  limit?: Maybe<Scalars['Int']>;
};

export type ArticlesPayload = {
  __typename?: 'ArticlesPayload';
  items: Array<Article>;
  total: Scalars['Int'];
};

export type ArticleTypeFilter = {
  __typename?: 'ArticleTypeFilter';
  articleTypeID: Scalars['Int'];
  articleType: Scalars['String'];
};

export type AttributeFilterFiltersInput = {
  attributeID: Scalars['Int'];
  attributeValueID: Array<Scalars['Int']>;
};

export type BrandCollectionFilter = {
  __typename?: 'BrandCollectionFilter';
  collectionNumber: Scalars['Int'];
  collection?: Maybe<Scalars['String']>;
};

export type BrandTypeFilter = {
  __typename?: 'BrandTypeFilter';
  merk_nr: Scalars['Int'];
  brand: Scalars['String'];
};

export type Cart = {
  __typename?: 'Cart';
  id: Scalars['String'];
  user?: Maybe<User>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  shippingCosts: Scalars['Int'];
  vouchers: Array<CartVoucher>;
  totalItems: Scalars['Int'];
  totalPriceIncTax: Scalars['Int'];
  totalPriceExTax: Scalars['Int'];
  totalTax: Scalars['Int'];
  items: Array<CartItem>;
};


export type CartVouchersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<CartVoucherWhereUniqueInput>;
  after?: Maybe<CartVoucherWhereUniqueInput>;
};

export type CartItem = {
  __typename?: 'CartItem';
  id: Scalars['String'];
  quantity: Scalars['Int'];
  articleId: Scalars['String'];
  unitPrice: Scalars['Int'];
  description: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  tax: Scalars['Float'];
  totalPrice: Scalars['Int'];
  article?: Maybe<Article>;
};

export type CartVoucher = {
  __typename?: 'CartVoucher';
  id: Scalars['String'];
  code: Scalars['String'];
  type: VoucherType;
  value: Scalars['Int'];
  createdAt: Scalars['DateTime'];
};

export type CartVoucherWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type CheckoutContactInput = {
  email: Scalars['String'];
  phone: Scalars['String'];
};

export type CheckoutCustomerInput = {
  email: Scalars['String'];
  name: Scalars['String'];
};

export type CheckoutInput = {
  contact: CheckoutContactInput;
  billingAddress: AddressInput;
  shippingAddress: AddressInput;
};

export type CheckoutMeta = {
  __typename?: 'CheckoutMeta';
  display_price: CheckoutMetaDisplayPrice;
};

export type CheckoutMetaDisplayPrice = {
  __typename?: 'CheckoutMetaDisplayPrice';
  with_tax: CheckoutMetaPrice;
  without_tax: CheckoutMetaPrice;
  tax: CheckoutMetaPrice;
};

export type CheckoutMetaInput = {
  giftWrap?: Maybe<Scalars['Boolean']>;
  giftWrapText?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  deliveryType?: Maybe<OrderDeliveryType>;
  newsletterSignup?: Maybe<Scalars['Boolean']>;
};

export type CheckoutMetaPrice = {
  __typename?: 'CheckoutMetaPrice';
  amount: Scalars['Int'];
  currency: Scalars['String'];
  formatted: Scalars['String'];
};

export type CheckoutPayload = {
  __typename?: 'CheckoutPayload';
  id: Scalars['String'];
  status: Scalars['String'];
  payment: Scalars['String'];
  meta: CheckoutMeta;
};

export type ContactFormInput = {
  gender: Gender;
  type: LeadType;
  name: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  preferredDate?: Maybe<Scalars['String']>;
  /** The location (mostly the URL) from which this is called. */
  referrer: Scalars['String'];
  /** The title of the page the form is send from */
  referrerTitle: Scalars['String'];
  articleId?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  store?: Maybe<Scalars['String']>;
};

export type CreateAccountInput = {
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  billingAddress: AddressInput;
  shippingAddress?: Maybe<AddressInput>;
};

export type CreateAdminInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  access: Array<UserAccess>;
};

export type CreateVoucherInput = {
  code: Scalars['String'];
  store: Store;
  status: VoucherStatus;
  description: Scalars['String'];
  type: VoucherType;
  value: Scalars['Int'];
  limit?: Maybe<Scalars['Int']>;
  validTill?: Maybe<Scalars['Date']>;
};



export type FilterPayload = {
  __typename?: 'FilterPayload';
  articleTypeFilters: Array<ArticleTypeFilter>;
  brandFilters: Array<BrandTypeFilter>;
  brandCollectionFilters: Array<BrandCollectionFilter>;
  articleAttributeFilters: Array<ArticleAttributeFilter>;
};

export enum Gender {
  Male = 'MALE',
  Female = 'FEMALE',
  Other = 'OTHER'
}


export type Lead = {
  __typename?: 'Lead';
  id: Scalars['String'];
  type: LeadType;
  status: LeadStatus;
  language: LeadLanguage;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  preferredDate?: Maybe<Scalars['String']>;
  gender: Gender;
  name: Scalars['String'];
  email: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  referrer: Scalars['String'];
  referrerTitle: Scalars['String'];
  articleId?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  store?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  responses: Array<LeadResponse>;
  activityLog: Array<ActivityLogEntry>;
};


export type LeadResponsesArgs = {
  orderBy?: Maybe<Array<LeadResponsesOrderByInput>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<LeadResponseWhereUniqueInput>;
  after?: Maybe<LeadResponseWhereUniqueInput>;
};


export type LeadActivityLogArgs = {
  orderBy?: Maybe<Array<LeadActivityLogOrderByInput>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ActivityLogEntryWhereUniqueInput>;
  after?: Maybe<ActivityLogEntryWhereUniqueInput>;
};

export type LeadActivityLogOrderByInput = {
  createdAt?: Maybe<SortOrder>;
};

export enum LeadLanguage {
  Nl = 'NL',
  En = 'EN'
}

export type LeadResponse = {
  __typename?: 'LeadResponse';
  id: Scalars['String'];
  message: Scalars['String'];
  user: User;
  createdAt: Scalars['DateTime'];
};

export type LeadResponsesOrderByInput = {
  createdAt?: Maybe<SortOrder>;
};

export type LeadResponseWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type LeadsFilterInput = {
  status?: Maybe<Array<LeadStatus>>;
  type?: Maybe<Array<LeadType>>;
  from?: Maybe<Scalars['DateTime']>;
  till?: Maybe<Scalars['DateTime']>;
  query?: Maybe<Scalars['String']>;
};

export type LeadsPayload = {
  __typename?: 'LeadsPayload';
  items: Array<Lead>;
  total: Scalars['Int'];
};

export enum LeadStatus {
  New = 'NEW',
  InProgress = 'IN_PROGRESS',
  Answered = 'ANSWERED'
}

export enum LeadType {
  Question = 'QUESTION',
  Appointment = 'APPOINTMENT',
  Contact = 'CONTACT'
}

export type LeadWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  authToken: Scalars['String'];
  refreshToken: Scalars['String'];
  user: User;
};

export enum LoginTo {
  Account = 'account',
  Admin = 'admin'
}

export type Mutation = {
  __typename?: 'Mutation';
  newsletterSignup: Scalars['Boolean'];
  deleteCart: Scalars['Boolean'];
  addArticleToCart: Cart;
  removeItemFromCart: Cart;
  updateCartItemQuantity: Cart;
  updateCartItemSize: Cart;
  addVoucher: Cart;
  removeVoucher: Cart;
  updateShippingCosts: Cart;
  payment: Scalars['Json'];
  paymentDetails: Scalars['Json'];
  /** Converts a cart to an order */
  checkout: Order;
  /**
   * This returns the full amount on the giftcard if the total cart amount is
   * higher then the giftcard value, else it wil return the total giftcard value
   */
  validateGiftCard: Scalars['Int'];
  returnOrderRequest: Scalars['Boolean'];
  addOrderMemo: Order;
  changeOrderStatus: Order;
  tourBooking: Scalars['String'];
  /** Creates a new checkout order */
  tourCheckout: Order;
  createAccount: LoginPayload;
  login: LoginPayload;
  renewToken: LoginPayload;
  requestResetPassword: Scalars['Boolean'];
  resetPassword: LoginPayload;
  createAdmin: User;
  updateAdmin: User;
  deleteAdmin: User;
  adminAccountActivation: LoginPayload;
  createVoucher: Voucher;
  updateVoucher: Voucher;
  deleteVoucher: Voucher;
  submitContactForm: Scalars['Boolean'];
  addLeadResponse: Lead;
  addLeadMemo: Lead;
  changeLeadStatus: Lead;
};


export type MutationNewsletterSignupArgs = {
  input: NewsletterSignupInput;
};


export type MutationDeleteCartArgs = {
  reference: Scalars['String'];
};


export type MutationAddArticleToCartArgs = {
  reference: Scalars['String'];
  articleId: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};


export type MutationRemoveItemFromCartArgs = {
  reference: Scalars['String'];
  cartItemId: Scalars['String'];
};


export type MutationUpdateCartItemQuantityArgs = {
  reference: Scalars['String'];
  cartItemId: Scalars['String'];
  quantity: Scalars['Int'];
};


export type MutationUpdateCartItemSizeArgs = {
  reference: Scalars['String'];
  cartItemId: Scalars['String'];
  size?: Maybe<Scalars['String']>;
};


export type MutationAddVoucherArgs = {
  reference: Scalars['String'];
  code: Scalars['String'];
};


export type MutationRemoveVoucherArgs = {
  reference: Scalars['String'];
  code: Scalars['String'];
};


export type MutationUpdateShippingCostsArgs = {
  reference: Scalars['String'];
  countryCode: Scalars['String'];
};


export type MutationPaymentArgs = {
  input: PaymentInput;
};


export type MutationPaymentDetailsArgs = {
  input: PaymentDetailsInput;
};


export type MutationCheckoutArgs = {
  reference: Scalars['String'];
  input?: Maybe<CheckoutInput>;
  meta?: Maybe<CheckoutMetaInput>;
};


export type MutationValidateGiftCardArgs = {
  reference: Scalars['String'];
  input: ValidateGiftCardInput;
};


export type MutationReturnOrderRequestArgs = {
  input: ReturnOrderRequestInput;
};


export type MutationAddOrderMemoArgs = {
  orderId: Scalars['Int'];
  memo: Scalars['String'];
};


export type MutationChangeOrderStatusArgs = {
  orderId: Scalars['Int'];
  status: OrderStatus;
  memo?: Maybe<Scalars['String']>;
};


export type MutationTourBookingArgs = {
  tourInput: TourBookingInput;
  clientInput?: Maybe<TourBookingClientInput>;
  tourOperatorInput?: Maybe<TourBookingTourOperatorInput>;
};


export type MutationTourCheckoutArgs = {
  code: Scalars['String'];
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  loginTo: LoginTo;
};


export type MutationRenewTokenArgs = {
  authToken: Scalars['String'];
  refreshToken: Scalars['String'];
};


export type MutationRequestResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  token: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationCreateAdminArgs = {
  input: CreateAdminInput;
};


export type MutationUpdateAdminArgs = {
  id: Scalars['String'];
  input: UpdateAdminInput;
};


export type MutationDeleteAdminArgs = {
  id: Scalars['String'];
};


export type MutationAdminAccountActivationArgs = {
  input: AdminAccountActivationInput;
};


export type MutationCreateVoucherArgs = {
  input: CreateVoucherInput;
};


export type MutationUpdateVoucherArgs = {
  id: Scalars['String'];
  input: UpdateVoucherInput;
};


export type MutationDeleteVoucherArgs = {
  id: Scalars['String'];
};


export type MutationSubmitContactFormArgs = {
  input: ContactFormInput;
  newsletterSignup?: Maybe<Scalars['Boolean']>;
};


export type MutationAddLeadResponseArgs = {
  id: Scalars['String'];
  subject: Scalars['String'];
  message: Scalars['String'];
};


export type MutationAddLeadMemoArgs = {
  leadId: Scalars['String'];
  memo: Scalars['String'];
};


export type MutationChangeLeadStatusArgs = {
  leadId: Scalars['String'];
  status: LeadStatus;
  memo?: Maybe<Scalars['String']>;
};

export type NestedStringFilter = {
  equals?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  notIn?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
};

export type NewsletterSignupInput = {
  salutation: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  birthdate?: Maybe<Scalars['String']>;
  gassanNewsletter?: Maybe<Scalars['Boolean']>;
  choicesNewsletter?: Maybe<Scalars['Boolean']>;
  /** Location where this user signed up */
  signedUpFrom?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['Int'];
  key: Scalars['String'];
  status: OrderStatus;
  store: Store;
  type: OrderType;
  contactFullName: Scalars['String'];
  contactEmail: Scalars['String'];
  contactPhone: Scalars['String'];
  user?: Maybe<User>;
  shippingCosts: Scalars['Int'];
  vouchers: Array<OrderVoucher>;
  shippingAddress: OrderAddress;
  billingAddress: OrderAddress;
  transactions: Array<Transaction>;
  deliveryType: OrderDeliveryType;
  message?: Maybe<Scalars['String']>;
  giftWrap: Scalars['Boolean'];
  giftWrapText?: Maybe<Scalars['String']>;
  activityLog: Array<ActivityLogEntry>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  totalPriceIncTax: Scalars['Int'];
  totalPriceExTax: Scalars['Int'];
  totalTax: Scalars['Int'];
  totalDiscount: Scalars['Int'];
  items: Array<OrderItem>;
};


export type OrderVouchersArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<OrderVoucherWhereUniqueInput>;
  after?: Maybe<OrderVoucherWhereUniqueInput>;
};


export type OrderTransactionsArgs = {
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<TransactionWhereUniqueInput>;
  after?: Maybe<TransactionWhereUniqueInput>;
};


export type OrderActivityLogArgs = {
  orderBy?: Maybe<Array<OrderActivityLogOrderByInput>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ActivityLogEntryWhereUniqueInput>;
  after?: Maybe<ActivityLogEntryWhereUniqueInput>;
};

export type OrderActivityLogOrderByInput = {
  createdAt?: Maybe<SortOrder>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  id: Scalars['String'];
  gender: Gender;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  street: Scalars['String'];
  houseNumber: Scalars['String'];
  houseNumberSuffix?: Maybe<Scalars['String']>;
  city: Scalars['String'];
};

export enum OrderDeliveryType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type OrderItem = {
  __typename?: 'OrderItem';
  id: Scalars['String'];
  quantity: Scalars['Int'];
  articleId: Scalars['String'];
  description: Scalars['String'];
  unitPrice: Scalars['Int'];
  size?: Maybe<Scalars['String']>;
  tax: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  totalPrice: Scalars['Int'];
  article?: Maybe<Article>;
};

export type OrdersFilterInput = {
  status?: Maybe<Array<OrderStatus>>;
  store?: Maybe<Array<Store>>;
  from?: Maybe<Scalars['String']>;
  till?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};

export type OrdersPayload = {
  __typename?: 'OrdersPayload';
  items: Array<Order>;
  total: Scalars['Int'];
};

export enum OrderStatus {
  New = 'NEW',
  Payed = 'PAYED',
  Fullfilled = 'FULLFILLED',
  NoStock = 'NO_STOCK',
  ReturnRegistered = 'RETURN_REGISTERED',
  ReturnProcessed = 'RETURN_PROCESSED'
}

export enum OrderType {
  ProductOrder = 'PRODUCT_ORDER',
  TourOrder = 'TOUR_ORDER'
}

export type OrderVoucher = {
  __typename?: 'OrderVoucher';
  id: Scalars['String'];
  code: Scalars['String'];
  type: VoucherType;
  value: Scalars['Int'];
  createdAt: Scalars['DateTime'];
};

export type OrderVoucherWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type OrderWhereUniqueInput = {
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
};

export type PaymentDetailsInput = {
  paymentData: Scalars['String'];
  MD: Scalars['String'];
  PaRes: Scalars['String'];
};

export type PaymentGiftcardInput = {
  giftcardNumber: Scalars['String'];
  securityCode: Scalars['String'];
  /** The amount in cents */
  amount: Scalars['Int'];
};

export type PaymentInput = {
  orderId: Scalars['Int'];
  email: Scalars['String'];
  paymentMethod?: Maybe<Scalars['Json']>;
  returnUrl: Scalars['String'];
  giftcard?: Maybe<PaymentGiftcardInput>;
  paypalOrderId?: Maybe<Scalars['String']>;
  shopperIP?: Maybe<Scalars['String']>;
  browserInfo?: Maybe<Scalars['Json']>;
};

export type PostalCodeLookupPayload = {
  __typename?: 'PostalCodeLookupPayload';
  id: Scalars['String'];
  postcode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  street?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  cart: Cart;
  article?: Maybe<Article>;
  articles: ArticlesPayload;
  articlesById: Array<Article>;
  filters: FilterPayload;
  paymentMethods: Scalars['Json'];
  verifyAdyenPayment: Scalars['Boolean'];
  postalCodeLookup?: Maybe<PostalCodeLookupPayload>;
  orderByIdAndEmail?: Maybe<Order>;
  orderForReturn?: Maybe<Order>;
  order?: Maybe<Order>;
  orders: OrdersPayload;
  getMyParcelLabelUrl?: Maybe<Scalars['String']>;
  tourByCodeAndEmail: TourBooking;
  me?: Maybe<User>;
  checkAccountExistence: Scalars['Boolean'];
  admins: AdminsPayload;
  admin: User;
  vouchers: VouchersPayload;
  voucher: Voucher;
  lead?: Maybe<Lead>;
  leads: LeadsPayload;
};


export type QueryCartArgs = {
  reference: Scalars['String'];
};


export type QueryArticleArgs = {
  id: Scalars['String'];
};


export type QueryArticlesArgs = {
  pagination?: Maybe<ArticlesPaginationInput>;
  filters?: Maybe<ArticlesFilterInput>;
};


export type QueryArticlesByIdArgs = {
  ids: Array<Scalars['String']>;
};


export type QueryFiltersArgs = {
  filters?: Maybe<ArticlesFilterInput>;
};


export type QueryPaymentMethodsArgs = {
  amount: Scalars['Int'];
};


export type QueryVerifyAdyenPaymentArgs = {
  payload: Scalars['String'];
};


export type QueryPostalCodeLookupArgs = {
  postalCode: Scalars['String'];
  houseNumber: Scalars['Int'];
};


export type QueryOrderByIdAndEmailArgs = {
  id: Scalars['Int'];
  email: Scalars['String'];
};


export type QueryOrderForReturnArgs = {
  id: Scalars['Int'];
  email: Scalars['String'];
};


export type QueryOrderArgs = {
  id: Scalars['Int'];
};


export type QueryOrdersArgs = {
  filter?: Maybe<OrdersFilterInput>;
  orderBy?: Maybe<QueryOrdersOrderByInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryGetMyParcelLabelUrlArgs = {
  myParcelId: Scalars['String'];
};


export type QueryTourByCodeAndEmailArgs = {
  code: Scalars['String'];
  email: Scalars['String'];
};


export type QueryCheckAccountExistenceArgs = {
  email: Scalars['String'];
};


export type QueryAdminsArgs = {
  filter?: Maybe<QueryUsersWhereInput>;
  orderBy?: Maybe<QueryUsersOrderByInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryAdminArgs = {
  id: Scalars['String'];
};


export type QueryVouchersArgs = {
  filter?: Maybe<VouchersFilterInput>;
  orderBy?: Maybe<QueryVouchersOrderByInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryVoucherArgs = {
  id: Scalars['String'];
};


export type QueryLeadArgs = {
  id: Scalars['String'];
};


export type QueryLeadsArgs = {
  filter?: Maybe<LeadsFilterInput>;
  orderBy?: Maybe<QueryLeadsOrderByInput>;
  take?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
};

export type QueryLeadsOrderByInput = {
  id?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  name?: Maybe<SortOrder>;
  referrerTitle?: Maybe<SortOrder>;
};

export type QueryOrdersOrderByInput = {
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  store?: Maybe<SortOrder>;
  totalPriceIncTax?: Maybe<SortOrder>;
  contactFullName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
};

export type QueryUsersOrderByInput = {
  id?: Maybe<SortOrder>;
  role?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  email?: Maybe<SortOrder>;
  fullName?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
  lastLogin?: Maybe<SortOrder>;
};

export type QueryUsersWhereInput = {
  id?: Maybe<StringFilter>;
  role?: Maybe<Role>;
  status?: Maybe<UserStatus>;
};

export type QueryVouchersOrderByInput = {
  id?: Maybe<SortOrder>;
  status?: Maybe<SortOrder>;
  store?: Maybe<SortOrder>;
  type?: Maybe<SortOrder>;
  validTill?: Maybe<SortOrder>;
  createdAt?: Maybe<SortOrder>;
  updatedAt?: Maybe<SortOrder>;
};

export type QueryVouchersWhereInput = {
  id?: Maybe<StringFilter>;
  status?: Maybe<VoucherStatus>;
  store?: Maybe<Store>;
  type?: Maybe<VoucherType>;
};

export type ReturnItem = {
  id?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
};

export type ReturnOrderRequestInput = {
  email: Scalars['String'];
  orderId: Scalars['Int'];
  items: Array<ReturnItem>;
};

export enum Role {
  Admin = 'ADMIN',
  User = 'USER'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum Store {
  Gassan = 'GASSAN',
  Choices = 'CHOICES'
}

export type StringFilter = {
  equals?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  notIn?: Maybe<Array<Scalars['String']>>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  contains?: Maybe<Scalars['String']>;
  startsWith?: Maybe<Scalars['String']>;
  endsWith?: Maybe<Scalars['String']>;
  not?: Maybe<NestedStringFilter>;
};

export type TourBooking = {
  __typename?: 'TourBooking';
  id: Scalars['String'];
  code: Scalars['String'];
  type: TourBookingType;
  status: TourBookingStatus;
  client: TourBookingClient;
  gender?: Maybe<Gender>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  phone: Scalars['String'];
  hotel: Scalars['String'];
  countryOfOrigin?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  tourLeader?: Maybe<Scalars['String']>;
  localGuide?: Maybe<Scalars['String']>;
  travelAgency?: Maybe<Scalars['String']>;
  clientName?: Maybe<Scalars['String']>;
  date: Scalars['String'];
  time: Scalars['String'];
  name: Scalars['String'];
  persons: Scalars['Int'];
  totalPrice: Scalars['Int'];
  prefferedLanguage: Scalars['String'];
  createdAt: Scalars['DateTime'];
};

export enum TourBookingClient {
  TourOperator = 'TOUR_OPERATOR',
  Client = 'CLIENT'
}

export type TourBookingClientInput = {
  gender: Gender;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  hotel: Scalars['String'];
  countryOfOrigin?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type TourBookingInput = {
  date: Scalars['String'];
  time: Scalars['String'];
  name: TourName;
  persons: Scalars['Int'];
  prefferedLanguage: Scalars['String'];
};

export enum TourBookingStatus {
  Complete = 'COMPLETE',
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

export type TourBookingTourOperatorInput = {
  tourLeader: Scalars['String'];
  localGuide: Scalars['String'];
  travelAgency: Scalars['String'];
  clientName: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  hotel: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export enum TourBookingType {
  Payed = 'PAYED',
  Free = 'FREE'
}

export enum TourName {
  GassanHistorischeTour = 'gassan_historische_tour',
  DiamondExperienceTour = 'diamond_experience_tour',
  GassanVipTour = 'gassan_vip_tour',
  DiamondPolishingExperienceTour = 'diamond_polishing_experience_tour',
  DiamondAndChampagneTour = 'diamond_and_champagne_tour'
}

export type Transaction = {
  __typename?: 'Transaction';
  id: Scalars['String'];
  type: TransactionType;
  reference?: Maybe<Scalars['String']>;
  amount: Scalars['Int'];
  paymentMethod?: Maybe<Scalars['String']>;
};

export enum TransactionType {
  Adyen = 'ADYEN',
  Paypal = 'PAYPAL',
  Giftcard = 'GIFTCARD'
}

export type TransactionWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
};

export type UpdateAdminInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  access?: Maybe<Array<UserAccess>>;
};

export type UpdateVoucherInput = {
  store: Store;
  status: VoucherStatus;
  description: Scalars['String'];
  type: VoucherType;
  value: Scalars['Int'];
  limit?: Maybe<Scalars['Int']>;
  validTill?: Maybe<Scalars['Date']>;
};

export type User = {
  __typename?: 'User';
  id: Scalars['String'];
  role: Role;
  salutation?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  fullName: Scalars['String'];
  email: Scalars['String'];
  status: UserStatus;
  access: Array<UserAccess>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lastLogin?: Maybe<Scalars['DateTime']>;
};

export enum UserAccess {
  Order = 'ORDER',
  Lead = 'LEAD',
  Voucher = 'VOUCHER',
  Admin = 'ADMIN'
}

export enum UserStatus {
  Pending = 'PENDING',
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Deleted = 'DELETED'
}

export type UserWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type ValidateGiftCardInput = {
  giftcardNumber: Scalars['String'];
  securityCode: Scalars['String'];
};

export type Voucher = {
  __typename?: 'Voucher';
  id: Scalars['String'];
  code: Scalars['String'];
  status: VoucherStatus;
  store: Store;
  description: Scalars['String'];
  type: VoucherType;
  value: Scalars['Int'];
  limit: Scalars['Int'];
  used: Scalars['Int'];
  validTill: Scalars['DateTime'];
  activityLog: Array<ActivityLogEntry>;
  createdBy: User;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};


export type VoucherActivityLogArgs = {
  orderBy?: Maybe<Array<ActivityLogEntryOrderByInput>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<ActivityLogEntryWhereUniqueInput>;
  after?: Maybe<ActivityLogEntryWhereUniqueInput>;
};

export type VouchersFilterInput = {
  status?: Maybe<Array<VoucherStatus>>;
  type?: Maybe<Array<VoucherType>>;
  validTill?: Maybe<Scalars['Date']>;
  query?: Maybe<Scalars['String']>;
};

export type VouchersPayload = {
  __typename?: 'VouchersPayload';
  items: Array<Voucher>;
  total: Scalars['Int'];
};

export enum VoucherStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Expired = 'EXPIRED',
  UsedUp = 'USED_UP',
  Deleted = 'DELETED'
}

export enum VoucherType {
  Percentage = 'PERCENTAGE',
  Absolute = 'ABSOLUTE'
}

export type VoucherWhereUniqueInput = {
  id?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type CartFragmentFragment = (
  { __typename?: 'Cart' }
  & Pick<Cart, 'id' | 'totalTax' | 'totalPriceExTax' | 'totalPriceIncTax' | 'totalItems' | 'shippingCosts'>
  & { vouchers: Array<(
    { __typename?: 'CartVoucher' }
    & Pick<CartVoucher, 'id' | 'type' | 'code' | 'value'>
  )>, items: Array<(
    { __typename?: 'CartItem' }
    & Pick<CartItem, 'id' | 'quantity' | 'unitPrice' | 'totalPrice' | 'description' | 'articleId' | 'size'>
    & { article?: Maybe<(
      { __typename?: 'Article' }
      & Pick<Article, 'id' | 'brand' | 'description' | 'articleType' | 'images' | 'price' | 'salePrice'>
      & { articleAttributes: Array<(
        { __typename?: 'ArticleAttribute' }
        & Pick<ArticleAttribute, 'attributeID' | 'attributeValue'>
      )> }
    )> }
  )> }
);

export type CartTotalItemsQueryVariables = Exact<{
  reference: Scalars['String'];
}>;


export type CartTotalItemsQuery = (
  { __typename?: 'Query' }
  & { cart: (
    { __typename?: 'Cart' }
    & Pick<Cart, 'id' | 'totalItems'>
  ) }
);

export type CartQueryVariables = Exact<{
  reference: Scalars['String'];
}>;


export type CartQuery = (
  { __typename?: 'Query' }
  & { cart: (
    { __typename?: 'Cart' }
    & CartFragmentFragment
  ) }
);

export type DeleteCartMutationVariables = Exact<{
  reference: Scalars['String'];
}>;


export type DeleteCartMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteCart'>
);

export type AddArticleToCartMutationVariables = Exact<{
  reference: Scalars['String'];
  articleId: Scalars['String'];
  size?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
}>;


export type AddArticleToCartMutation = (
  { __typename?: 'Mutation' }
  & { addArticleToCart: (
    { __typename?: 'Cart' }
    & CartFragmentFragment
  ) }
);

export type RemoveItemFromCartMutationVariables = Exact<{
  reference: Scalars['String'];
  cartItemId: Scalars['String'];
}>;


export type RemoveItemFromCartMutation = (
  { __typename?: 'Mutation' }
  & { removeItemFromCart: (
    { __typename?: 'Cart' }
    & CartFragmentFragment
  ) }
);

export type UpdateCartItemQuantityMutationVariables = Exact<{
  reference: Scalars['String'];
  cartItemId: Scalars['String'];
  quantity: Scalars['Int'];
}>;


export type UpdateCartItemQuantityMutation = (
  { __typename?: 'Mutation' }
  & { updateCartItemQuantity: (
    { __typename?: 'Cart' }
    & CartFragmentFragment
  ) }
);

export type UpdateCartItemSizeMutationVariables = Exact<{
  reference: Scalars['String'];
  cartItemId: Scalars['String'];
  size?: Maybe<Scalars['String']>;
}>;


export type UpdateCartItemSizeMutation = (
  { __typename?: 'Mutation' }
  & { updateCartItemSize: (
    { __typename?: 'Cart' }
    & CartFragmentFragment
  ) }
);

export type UpdateShippingCostsMutationVariables = Exact<{
  reference: Scalars['String'];
  countryCode: Scalars['String'];
}>;


export type UpdateShippingCostsMutation = (
  { __typename?: 'Mutation' }
  & { updateShippingCosts: (
    { __typename?: 'Cart' }
    & CartFragmentFragment
  ) }
);

export type AddVoucherMutationVariables = Exact<{
  reference: Scalars['String'];
  code: Scalars['String'];
}>;


export type AddVoucherMutation = (
  { __typename?: 'Mutation' }
  & { addVoucher: (
    { __typename?: 'Cart' }
    & CartFragmentFragment
  ) }
);

export type RemoveVoucherMutationVariables = Exact<{
  reference: Scalars['String'];
  code: Scalars['String'];
}>;


export type RemoveVoucherMutation = (
  { __typename?: 'Mutation' }
  & { removeVoucher: (
    { __typename?: 'Cart' }
    & CartFragmentFragment
  ) }
);

export type OrderFieldsFragment = (
  { __typename?: 'Order' }
  & Pick<Order, 'id' | 'status' | 'contactEmail' | 'contactPhone' | 'totalPriceIncTax' | 'totalPriceExTax' | 'totalTax' | 'shippingCosts' | 'createdAt'>
  & { vouchers: Array<(
    { __typename?: 'OrderVoucher' }
    & Pick<OrderVoucher, 'id' | 'type' | 'code' | 'value'>
  )>, items: Array<(
    { __typename?: 'OrderItem' }
    & Pick<OrderItem, 'id' | 'quantity' | 'unitPrice' | 'totalPrice' | 'description' | 'articleId' | 'size'>
    & { article?: Maybe<(
      { __typename?: 'Article' }
      & Pick<Article, 'id' | 'brand' | 'description' | 'articleType' | 'images' | 'price' | 'salePrice'>
      & { articleAttributes: Array<(
        { __typename?: 'ArticleAttribute' }
        & Pick<ArticleAttribute, 'attributeID' | 'attributeValue'>
      )> }
    )> }
  )>, shippingAddress: (
    { __typename?: 'OrderAddress' }
    & Pick<OrderAddress, 'firstName' | 'lastName'>
  ) }
);

export type CheckoutMutationVariables = Exact<{
  reference: Scalars['String'];
  input: CheckoutInput;
  meta?: Maybe<CheckoutMetaInput>;
}>;


export type CheckoutMutation = (
  { __typename?: 'Mutation' }
  & { checkout: (
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'status'>
  ) }
);

export type OrderByIdAndEmailQueryVariables = Exact<{
  id: Scalars['Int'];
  email: Scalars['String'];
}>;


export type OrderByIdAndEmailQuery = (
  { __typename?: 'Query' }
  & { orderByIdAndEmail?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'deliveryType'>
    & { shippingAddress: (
      { __typename?: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'gender' | 'companyName' | 'firstName' | 'lastName' | 'street' | 'houseNumber' | 'houseNumberSuffix' | 'postalCode' | 'city' | 'country'>
    ), billingAddress: (
      { __typename?: 'OrderAddress' }
      & Pick<OrderAddress, 'id' | 'gender' | 'companyName' | 'firstName' | 'lastName' | 'street' | 'houseNumber' | 'houseNumberSuffix' | 'postalCode' | 'city' | 'country'>
    ), transactions: Array<(
      { __typename?: 'Transaction' }
      & Pick<Transaction, 'type' | 'paymentMethod'>
    )> }
    & OrderFieldsFragment
  )> }
);

export type PaymentMethodsQueryVariables = Exact<{
  amount: Scalars['Int'];
}>;


export type PaymentMethodsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'paymentMethods'>
);

export type PaymentMutationVariables = Exact<{
  input: PaymentInput;
}>;


export type PaymentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'payment'>
);

export type PaymentDetailsMutationVariables = Exact<{
  input: PaymentDetailsInput;
}>;


export type PaymentDetailsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'paymentDetails'>
);

export type VerifyAdyenPaymentQueryVariables = Exact<{
  payload: Scalars['String'];
}>;


export type VerifyAdyenPaymentQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'verifyAdyenPayment'>
);

export type ValidateGiftCardMutationVariables = Exact<{
  reference: Scalars['String'];
  input: ValidateGiftCardInput;
}>;


export type ValidateGiftCardMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'validateGiftCard'>
);

export type ReturnOrderRequestMutationVariables = Exact<{
  input: ReturnOrderRequestInput;
}>;


export type ReturnOrderRequestMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'returnOrderRequest'>
);

export type OrderForReturnQueryVariables = Exact<{
  id: Scalars['Int'];
  email: Scalars['String'];
}>;


export type OrderForReturnQuery = (
  { __typename?: 'Query' }
  & { orderForReturn?: Maybe<(
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'status' | 'contactEmail' | 'contactPhone'>
    & { items: Array<(
      { __typename?: 'OrderItem' }
      & Pick<OrderItem, 'id' | 'quantity' | 'unitPrice' | 'totalPrice' | 'description' | 'articleId' | 'size'>
      & { article?: Maybe<(
        { __typename?: 'Article' }
        & Pick<Article, 'id' | 'brand' | 'description' | 'articleType' | 'images' | 'price' | 'salePrice'>
      )> }
    )>, shippingAddress: (
      { __typename?: 'OrderAddress' }
      & Pick<OrderAddress, 'firstName' | 'lastName'>
    ) }
  )> }
);

export type SubmitContactFormMutationVariables = Exact<{
  input: ContactFormInput;
  newsletterSignup?: Maybe<Scalars['Boolean']>;
}>;


export type SubmitContactFormMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'submitContactForm'>
);

export type TourBookingMutationVariables = Exact<{
  tourInput: TourBookingInput;
  clientInput?: Maybe<TourBookingClientInput>;
  tourOperatorInput?: Maybe<TourBookingTourOperatorInput>;
}>;


export type TourBookingMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'tourBooking'>
);

export type TourByCodeAndEmailQueryVariables = Exact<{
  code: Scalars['String'];
  email: Scalars['String'];
}>;


export type TourByCodeAndEmailQuery = (
  { __typename?: 'Query' }
  & { tourByCodeAndEmail: (
    { __typename?: 'TourBooking' }
    & Pick<TourBooking, 'name' | 'code' | 'persons' | 'email' | 'date' | 'time'>
  ) }
);

export type TourCheckoutMutationVariables = Exact<{
  code: Scalars['String'];
}>;


export type TourCheckoutMutation = (
  { __typename?: 'Mutation' }
  & { tourCheckout: (
    { __typename?: 'Order' }
    & Pick<Order, 'id' | 'status'>
  ) }
);

export const CartFragmentFragmentDoc = gql`
    fragment CartFragment on Cart {
  id
  totalTax
  totalPriceExTax
  totalPriceIncTax
  totalItems
  shippingCosts
  vouchers {
    id
    type
    code
    value
  }
  items {
    id
    quantity
    unitPrice
    totalPrice
    description
    articleId
    size
    article {
      id
      brand
      description
      articleType
      images
      price
      salePrice
      articleAttributes {
        attributeID
        attributeValue
      }
    }
  }
}
    `;
export const OrderFieldsFragmentDoc = gql`
    fragment OrderFields on Order {
  id
  status
  contactEmail
  contactPhone
  totalPriceIncTax
  totalPriceExTax
  totalTax
  shippingCosts
  createdAt
  vouchers {
    id
    type
    code
    value
  }
  items {
    id
    quantity
    unitPrice
    totalPrice
    description
    articleId
    size
    article {
      id
      brand
      description
      articleType
      images
      price
      salePrice
      articleAttributes {
        attributeID
        attributeValue
      }
    }
  }
  shippingAddress {
    firstName
    lastName
  }
}
    `;
export const CartTotalItemsDocument = gql`
    query CartTotalItems($reference: String!) {
  cart(reference: $reference) {
    id
    totalItems
  }
}
    `;

export function useCartTotalItemsQuery(options: Omit<Urql.UseQueryArgs<CartTotalItemsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CartTotalItemsQuery>({ query: CartTotalItemsDocument, ...options });
};
export const CartDocument = gql`
    query Cart($reference: String!) {
  cart(reference: $reference) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

export function useCartQuery(options: Omit<Urql.UseQueryArgs<CartQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<CartQuery>({ query: CartDocument, ...options });
};
export const DeleteCartDocument = gql`
    mutation DeleteCart($reference: String!) {
  deleteCart(reference: $reference)
}
    `;

export function useDeleteCartMutation() {
  return Urql.useMutation<DeleteCartMutation, DeleteCartMutationVariables>(DeleteCartDocument);
};
export const AddArticleToCartDocument = gql`
    mutation AddArticleToCart($reference: String!, $articleId: String!, $size: String, $quantity: Int) {
  addArticleToCart(reference: $reference, articleId: $articleId, size: $size, quantity: $quantity) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

export function useAddArticleToCartMutation() {
  return Urql.useMutation<AddArticleToCartMutation, AddArticleToCartMutationVariables>(AddArticleToCartDocument);
};
export const RemoveItemFromCartDocument = gql`
    mutation RemoveItemFromCart($reference: String!, $cartItemId: String!) {
  removeItemFromCart(reference: $reference, cartItemId: $cartItemId) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

export function useRemoveItemFromCartMutation() {
  return Urql.useMutation<RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables>(RemoveItemFromCartDocument);
};
export const UpdateCartItemQuantityDocument = gql`
    mutation UpdateCartItemQuantity($reference: String!, $cartItemId: String!, $quantity: Int!) {
  updateCartItemQuantity(reference: $reference, cartItemId: $cartItemId, quantity: $quantity) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

export function useUpdateCartItemQuantityMutation() {
  return Urql.useMutation<UpdateCartItemQuantityMutation, UpdateCartItemQuantityMutationVariables>(UpdateCartItemQuantityDocument);
};
export const UpdateCartItemSizeDocument = gql`
    mutation UpdateCartItemSize($reference: String!, $cartItemId: String!, $size: String) {
  updateCartItemSize(reference: $reference, cartItemId: $cartItemId, size: $size) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

export function useUpdateCartItemSizeMutation() {
  return Urql.useMutation<UpdateCartItemSizeMutation, UpdateCartItemSizeMutationVariables>(UpdateCartItemSizeDocument);
};
export const UpdateShippingCostsDocument = gql`
    mutation UpdateShippingCosts($reference: String!, $countryCode: String!) {
  updateShippingCosts(reference: $reference, countryCode: $countryCode) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

export function useUpdateShippingCostsMutation() {
  return Urql.useMutation<UpdateShippingCostsMutation, UpdateShippingCostsMutationVariables>(UpdateShippingCostsDocument);
};
export const AddVoucherDocument = gql`
    mutation AddVoucher($reference: String!, $code: String!) {
  addVoucher(reference: $reference, code: $code) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

export function useAddVoucherMutation() {
  return Urql.useMutation<AddVoucherMutation, AddVoucherMutationVariables>(AddVoucherDocument);
};
export const RemoveVoucherDocument = gql`
    mutation RemoveVoucher($reference: String!, $code: String!) {
  removeVoucher(reference: $reference, code: $code) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;

export function useRemoveVoucherMutation() {
  return Urql.useMutation<RemoveVoucherMutation, RemoveVoucherMutationVariables>(RemoveVoucherDocument);
};
export const CheckoutDocument = gql`
    mutation Checkout($reference: String!, $input: CheckoutInput!, $meta: CheckoutMetaInput) {
  checkout(reference: $reference, input: $input, meta: $meta) {
    id
    status
  }
}
    `;

export function useCheckoutMutation() {
  return Urql.useMutation<CheckoutMutation, CheckoutMutationVariables>(CheckoutDocument);
};
export const OrderByIdAndEmailDocument = gql`
    query OrderByIdAndEmail($id: Int!, $email: String!) {
  orderByIdAndEmail(id: $id, email: $email) {
    ...OrderFields
    deliveryType
    shippingAddress {
      id
      gender
      companyName
      firstName
      lastName
      street
      houseNumber
      houseNumberSuffix
      postalCode
      city
      country
    }
    billingAddress {
      id
      gender
      companyName
      firstName
      lastName
      street
      houseNumber
      houseNumberSuffix
      postalCode
      city
      country
    }
    transactions {
      type
      paymentMethod
    }
  }
}
    ${OrderFieldsFragmentDoc}`;

export function useOrderByIdAndEmailQuery(options: Omit<Urql.UseQueryArgs<OrderByIdAndEmailQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OrderByIdAndEmailQuery>({ query: OrderByIdAndEmailDocument, ...options });
};
export const PaymentMethodsDocument = gql`
    query PaymentMethods($amount: Int!) {
  paymentMethods(amount: $amount)
}
    `;

export function usePaymentMethodsQuery(options: Omit<Urql.UseQueryArgs<PaymentMethodsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<PaymentMethodsQuery>({ query: PaymentMethodsDocument, ...options });
};
export const PaymentDocument = gql`
    mutation Payment($input: PaymentInput!) {
  payment(input: $input)
}
    `;

export function usePaymentMutation() {
  return Urql.useMutation<PaymentMutation, PaymentMutationVariables>(PaymentDocument);
};
export const PaymentDetailsDocument = gql`
    mutation PaymentDetails($input: PaymentDetailsInput!) {
  paymentDetails(input: $input)
}
    `;

export function usePaymentDetailsMutation() {
  return Urql.useMutation<PaymentDetailsMutation, PaymentDetailsMutationVariables>(PaymentDetailsDocument);
};
export const VerifyAdyenPaymentDocument = gql`
    query VerifyAdyenPayment($payload: String!) {
  verifyAdyenPayment(payload: $payload)
}
    `;

export function useVerifyAdyenPaymentQuery(options: Omit<Urql.UseQueryArgs<VerifyAdyenPaymentQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<VerifyAdyenPaymentQuery>({ query: VerifyAdyenPaymentDocument, ...options });
};
export const ValidateGiftCardDocument = gql`
    mutation ValidateGiftCard($reference: String!, $input: ValidateGiftCardInput!) {
  validateGiftCard(reference: $reference, input: $input)
}
    `;

export function useValidateGiftCardMutation() {
  return Urql.useMutation<ValidateGiftCardMutation, ValidateGiftCardMutationVariables>(ValidateGiftCardDocument);
};
export const ReturnOrderRequestDocument = gql`
    mutation ReturnOrderRequest($input: ReturnOrderRequestInput!) {
  returnOrderRequest(input: $input)
}
    `;

export function useReturnOrderRequestMutation() {
  return Urql.useMutation<ReturnOrderRequestMutation, ReturnOrderRequestMutationVariables>(ReturnOrderRequestDocument);
};
export const OrderForReturnDocument = gql`
    query OrderForReturn($id: Int!, $email: String!) {
  orderForReturn(id: $id, email: $email) {
    id
    status
    contactEmail
    contactPhone
    items {
      id
      quantity
      unitPrice
      totalPrice
      description
      articleId
      size
      article {
        id
        brand
        description
        articleType
        images
        price
        salePrice
      }
    }
    shippingAddress {
      firstName
      lastName
    }
  }
}
    `;

export function useOrderForReturnQuery(options: Omit<Urql.UseQueryArgs<OrderForReturnQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<OrderForReturnQuery>({ query: OrderForReturnDocument, ...options });
};
export const SubmitContactFormDocument = gql`
    mutation SubmitContactForm($input: ContactFormInput!, $newsletterSignup: Boolean) {
  submitContactForm(input: $input, newsletterSignup: $newsletterSignup)
}
    `;

export function useSubmitContactFormMutation() {
  return Urql.useMutation<SubmitContactFormMutation, SubmitContactFormMutationVariables>(SubmitContactFormDocument);
};
export const TourBookingDocument = gql`
    mutation TourBooking($tourInput: TourBookingInput!, $clientInput: TourBookingClientInput, $tourOperatorInput: TourBookingTourOperatorInput) {
  tourBooking(tourInput: $tourInput, clientInput: $clientInput, tourOperatorInput: $tourOperatorInput)
}
    `;

export function useTourBookingMutation() {
  return Urql.useMutation<TourBookingMutation, TourBookingMutationVariables>(TourBookingDocument);
};
export const TourByCodeAndEmailDocument = gql`
    query TourByCodeAndEmail($code: String!, $email: String!) {
  tourByCodeAndEmail(code: $code, email: $email) {
    name
    code
    persons
    email
    date
    time
  }
}
    `;

export function useTourByCodeAndEmailQuery(options: Omit<Urql.UseQueryArgs<TourByCodeAndEmailQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<TourByCodeAndEmailQuery>({ query: TourByCodeAndEmailDocument, ...options });
};
export const TourCheckoutDocument = gql`
    mutation TourCheckout($code: String!) {
  tourCheckout(code: $code) {
    id
    status
  }
}
    `;

export function useTourCheckoutMutation() {
  return Urql.useMutation<TourCheckoutMutation, TourCheckoutMutationVariables>(TourCheckoutDocument);
};